import { useFormik } from 'formik';
import { useEffect } from 'react';
import { CasesGeneralInformation } from '../../../../../../shared/types/modules/cases-general-information';

export const useCasesGeneralInformationRegisterHistory = (
    casesGeneralInformation?: CasesGeneralInformation
) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = casesGeneralInformation || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [casesGeneralInformation]);

    return {
        formik,
    };
};
